import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();
  const { language } = useLanguage();

  const handleLinkClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <img src="/logo.png" alt="Tabia Group" className="footer-logo-img" />
          </div>

          <div className="footer-section">
            <ul className="footer-links">
              <li><Link to={language === 'en' ? '/en/grupo' : '/grupo'} onClick={handleLinkClick}>
                {language === 'en' ? 'Group' : 'Grupo'}
              </Link></li>
              <li><Link to={language === 'en' ? '/en/gestion' : '/gestion'} onClick={handleLinkClick}>
                {language === 'en' ? 'Management' : 'Gestión'}
              </Link></li>
              <li><Link to={language === 'en' ? '/en/inmobiliaria' : '/inmobiliaria'} onClick={handleLinkClick}>
                {language === 'en' ? 'Real Estate' : 'Inmobiliaria'}
              </Link></li>
              <li><Link to={language === 'en' ? '/en/activos' : '/activos'} onClick={handleLinkClick}>
                {language === 'en' ? 'Assets' : 'Activos'}
              </Link></li>
              <li><Link to={language === 'en' ? '/en/medios' : '/medios'} onClick={handleLinkClick}>
                {language === 'en' ? 'Media' : 'Medios'}
              </Link></li>
              <li><Link to={language === 'en' ? '/en/contacto' : '/contacto'} onClick={handleLinkClick}>
                {language === 'en' ? 'Contact' : 'Contacto'}
              </Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <div className="footer-contact">
              <p><strong>{language === 'en' ? 'Find Us' : 'Dónde encontrarnos'}</strong></p>
              <p>Calle de la Gerreria, 26. 1ºB</p>
              <p>07002, Palma, Balearic Islands</p>
              <p><a href="tel:+34871533824">+34 871 533 824</a></p>
              <p><a href="mailto:info@tabiagroup.com">info@tabiagroup.com</a></p>
              <div className="social-links" style={{marginTop: '1rem'}}>
                <a href="https://es.linkedin.com/company/tabia-group" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="LinkedIn">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
                <a href="https://www.instagram.com/tabiagroup/" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Tabia Group. All rights reserved.</p>
          <div className="footer-legal-links">
            <Link to={language === 'en' ? '/en/legal-notice' : '/aviso-legal'} onClick={handleLinkClick}>{language === 'en' ? 'Legal notice' : 'Aviso legal'}</Link>
            <Link to={language === 'en' ? '/en/privacy-policy' : '/politica-de-privacidad'} onClick={handleLinkClick}>{language === 'en' ? 'Privacy policy' : 'Política de privacidad'}</Link>
            <Link to={language === 'en' ? '/en/cookie-policy' : '/politica-de-cookies'} onClick={handleLinkClick}>{language === 'en' ? 'Cookie policy' : 'Política de cookies'}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
